import { Controller } from "@hotwired/stimulus"

// Manages a click-expand/collapse submenu. Set data-submenu-open-value="true"
// on the controller element to have the submenu start open (e.g. when the
// current page is within the submenu's section). Clicking outside the
// controller element will close the submenu.
export default class extends Controller {
  static targets = ["menu", "chevron"]
  static values = { open: Boolean }

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  openValueChanged() {
    const isOpen = this.openValue

    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle("hidden", !isOpen)
    }

    const trigger = this.element.querySelector("[aria-expanded]")
    if (trigger) {
      trigger.setAttribute("aria-expanded", String(isOpen))
    }

    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", isOpen)
    }
  }
}
